import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f71d4014&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "@/styles/main.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "@dash/styles/dashboard.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports